import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { causalApi, yesterday } from './causalApi';

export function useCausalPeriod(allGroups = false, cacheKey = null) {
  const [params] = useSearchParams();
  const [saved] = useState(() => {
    try { return cacheKey ? (JSON.parse(localStorage.getItem(cacheKey) || '{}') || {}) : {}; } catch { return {}; }
  });
  const [groups, setGroups] = useState([]);
  const [group, setGroup] = useState(params.get('group_id') ?? saved.group ?? '');
  const [start, setStart] = useState(params.get('start_date') || params.get('day') || saved.start || yesterday());
  const [end, setEnd] = useState(params.get('end_date') || params.get('day') || saved.end || yesterday());
  const [error, setError] = useState('');
  useEffect(() => {
    if (!cacheKey) return;
    try { localStorage.setItem(cacheKey, JSON.stringify({ group, start, end })); } catch { /* Storage may be disabled. */ }
  }, [cacheKey, group, start, end]);
  useEffect(() => {
    let live = true;
    causalApi('groups').then(rows => {
      if (!live) return;
      const unique = [...new Map(rows.map(row => [String(row.group_id), row])).values()];
      setGroups(unique);
      if (!allGroups) setGroup(old => old || String(unique[0]?.group_id || ''));
    }).catch(err => { if (live) setError(err.message); });
    return () => { live = false; };
  }, [allGroups]);
  const periodError = !start || !end ? 'Укажите обе даты' : start > end ? 'Дата «от» позже даты «до»'
    : (Date.parse(end) - Date.parse(start)) / 86400000 > 365 ? 'Выберите период до 366 дней' : '';
  const query = new URLSearchParams({ start_date: start, end_date: end, ...(group ? { group_id: group } : {}) }).toString();
  return { groups, group, setGroup, start, setStart, end, setEnd, error: error || periodError,
    ready: !error && !periodError && (allGroups || Boolean(group)), query, allGroups };
}

export default function CausalPeriod({ period, children }) {
  return <div className="causal-toolbar">
    <label className="causal-community">Сообщество<select className="form-select form-select-sm" value={period.group} onChange={e => period.setGroup(e.target.value)}>
      {period.allGroups && <option value="">Все сообщества</option>}
      {period.groups.map(row => <option key={row.group_id} value={row.group_id}>{row.title || row.group_id}</option>)}
    </select></label>
    <label>От<input className="form-control form-control-sm" type="date" value={period.start} max={period.end || undefined} onChange={e => period.setStart(e.target.value)} /></label>
    <label>До<input className="form-control form-control-sm" type="date" value={period.end} min={period.start || undefined} onChange={e => period.setEnd(e.target.value)} /></label>
    {children}
  </div>;
}
